import { createContext } from "react"
import React from "react"
import { ContratoAplicativoInicial } from "../models/contratoAplicativoModel"
import type { ContratoAplicativoModel } from "../models/contratoAplicativoModel"
import type { ContratoAplicativoActionModel } from "./contratoAplicativoActions"

type ContratoAplicativoContextProps = {
    dados: ContratoAplicativoModel
    dispatch: React.Dispatch<ContratoAplicativoActionModel>
    salvar: () => Promise<void>
    erroCarregamento: string | null
}

const initialContextValue: ContratoAplicativoContextProps = {
    dados: ContratoAplicativoInicial,
    dispatch: () => {},
    salvar: async () => {},
    erroCarregamento: null,
}

export const ContratoAplicativoContext =
    createContext<ContratoAplicativoContextProps>(initialContextValue)
